import styled from 'styled-components'

export const Title = styled.div`
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 16px;
`

export const Description = styled.div`
  font-weight: 400;
  color: #000000;
  margin-bottom: 24px;
`

export const RankmiTableWrapper = styled.div`
  .ant-table-wrapper {
    margin-top: -9px;
  }
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;

  ${Description} {
    margin-bottom: 0;
  }
`
